// Tiny event bus so nav links can open overlays on "/" without URL changes.
export type OverlayPayload = { path: string; label?: string };

const EVT = "pi:open-overlay";

export function openOverlay(payload: OverlayPayload) {
  if (typeof window === "undefined") return;
  // Defer one tick so the listener (on /) is mounted after navigation.
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent<OverlayPayload>(EVT, { detail: payload }));
  }, 0);
}

export function onOverlay(handler: (p: OverlayPayload) => void) {
  if (typeof window === "undefined") return () => {};
  const fn = (e: Event) => handler((e as CustomEvent<OverlayPayload>).detail);
  window.addEventListener(EVT, fn);
  return () => window.removeEventListener(EVT, fn);
}

// Pending payload bridge for cross-route navigation.
const KEY = "pi:pending-overlay";
export function setPendingOverlay(p: OverlayPayload) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(p));
  } catch {}
}
export function takePendingOverlay(): OverlayPayload | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw) as OverlayPayload;
  } catch {
    return null;
  }
}
